import { SelectTicketModalItem } from "components/TicketingModal/SelectTicketModal";
import { atom } from "jotai";
export const successAtom = atom(false);
export const languageAtom = atom("en");
export const emailModalAtom = atom(false);
export const ticketingModalOpenAtom = atom(false);
export const orderSummaryOpenAtom = atom(false);
export const ticketsAtom = atom([]);
export const selectedTicketAtom = atom(null);
export const checkoutFormLoadingAtom = atom(false);
export const ticketingModalItemAtom = atom(SelectTicketModalItem);
export const openPaymentErrorModalAtom = atom(false);
